import { Button } from '@mui/material';
import { CloseIcon } from '@tix-ticketing/ui-icons/outline';
import React from 'react';
interface ReceiptsItemProps {
  active: boolean;
  action?: any;
  clearable: boolean;
  onClear: any;
  label: React.ReactNode;
  customEndIcon?: React.ReactNode;
}
export const EventFilterButton = ({
  active,
  action,
  clearable,
  onClear,
  label,
  customEndIcon,
  ...rest
}: ReceiptsItemProps) => {
  return <Button variant="outlined" color="monochrome" onClick={action} endIcon={clearable ? customEndIcon ? customEndIcon : <CloseIcon sx={{
    ml: 1,
    color: 'primary.main'
  }} onClick={e => {
    e.stopPropagation();
    onClear();
  }} /> : undefined} sx={[clearable ? {
    borderColor: 'primary.main'
  } : {
    borderColor: null
  }, theme => active ? {
    backgroundColor: theme.palette.action.hover
  } : {
    backgroundColor: null
  }, clearable ? {
    '&:hover': {
      borderColor: 'primary.dark'
    }
  } : {
    '&:hover': {
      borderColor: null
    }
  }]} {...rest}>
      {label}
    </Button>;
};